import { useAppSelector } from '../../hooks';
import RegisterForm from './RegisterForm';
import RegisteredScreen from './RegisteredScreen';

export default function Register() {
  const registered = useAppSelector((s) => s.register.registered);
  return (
    <div className="register">
      <h2>REJESTRUJ</h2>
      {registered ? <RegisteredScreen /> : <RegisterForm />}
    </div>
  );
}
